export default {"src":"/_next/static/media/flag-EC.747fa080.svg","height":17,"width":24,"blurWidth":0,"blurHeight":0};